import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Button from "components/CustomButtons/Button.js";
import Close from "@material-ui/icons/Close";
import classNames from "classnames";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import get, { post } from "../../../lib/requests";

import {
	LoadingMgs,
	SuccessMessage,
	ErrorMessage,
} from "../../Common/toastify";
import { setUser } from "redux/ducks/userSlice";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";

const useStyles3 = makeStyles(javascriptStyles);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});
Transition.displayName = "Transition";

const InformationDialog = ({
	informationDialogShow,
	setInformationDialogShow,
	selectedDialogData,
	setSelectedDialogData,
	setRequestAccessShow,
	requestAccessShow,
	requestService,
	setRequestService,
}) => {
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const classes3 = useStyles3();
	const dispatch = useDispatch();
	const [loading, setLoading] = React.useState(false);
	const userDetails = useSelector((state) => state.user);
	const navigate = useNavigate();

	const requestAccess = () => {
		if (userDetails && userDetails["services-assigned"]) {
			if (selectedDialogData.iframe === true) {
				const assignService = userDetails["services-assigned"].find(
					(service) => service === selectedDialogData.Heading
				);
				if (assignService) {
					window.open(selectedDialogData.orderManual, "_blank");
				} else {
					accessRequest();
				}
				return;
			}

			if (selectedDialogData.orderManual === "manual_form") {
				navigate("/manual-order");
			} else if (selectedDialogData.orderManual === "manual_form_kinetix") {
				navigate("/manual-order-kinetix");
			} else if (selectedDialogData.orderManual !== "") {
				window.open(selectedDialogData.orderManual, "_blank");
			}
		} else {
			setRequestAccessShow(true);
			setRequestService(selectedDialogData.Heading);
		}
		setInformationDialogShow(false);
	};

	const accessRequest = async () => {
		setLoading(true);
		LoadingMgs("Request Access", "processing...");
		const formField = {
			service: selectedDialogData.Heading,
		};
		try {
			await post("/api/accessrequest", formField, true)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage("Request Access", res.data.message);
						if (res.data.records.haveaccess) {
							console.log(res.data.records.haveaccess, "res.data.haveaccess");
							verifyLogin();
						}
					} else {
						ErrorMessage("Request Access", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Request Access", message);
					setLoading(false);
				});
		} catch (error) {
			console.log("error", error);
			ErrorMessage("Request Access", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const verifyLogin = async () => {
		try {
			await get("/api/verifylogin", true)
				.then((res) => {
					if (res.data.success) {
						dispatch(setUser(res.data.records));
					} else {
						ErrorMessage("Request Access", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Request Access", message);
					setLoading(false);
				});
		} catch (error) {
			console.log("error", error);
			ErrorMessage("Request Access", "Something went wrong try again!!");
			setLoading(false);
		}
	};
	const checkIfHaveAccess = (service) => {
		console.log("userDetails", userDetails);
		if (userDetails && userDetails["services-assigned"]) {
			const assignService = userDetails["services-assigned"].find(
				(service) => service === selectedDialogData.Heading
			);

			if (selectedDialogData.orderManual === "manual_form" && assignService) {
				return "Place a Manual Order " + selectedDialogData.Heading;
			} else if (
				selectedDialogData.orderManual === "manual_form_kinetix" &&
				assignService
			) {
				return "Place a Manual Order " + selectedDialogData.Heading;
			} else if (selectedDialogData.orderManual !== "" && assignService) {
				return "Login to " + selectedDialogData.Heading;
			} else {
				return selectedDialogData.requestAcess;
			}
		} else {
			return selectedDialogData.requestAcess;
		}
	};

	return (
		<Dialog
			classes={{
				root: classes3.modalRoot,
				paper: classes3.modal,
			}}
			open={informationDialogShow}
			TransitionComponent={Transition}
			keepMounted
			onClose={() => setInformationDialogShow(false)}
			aria-labelledby="classic-modal-slide-title"
			aria-describedby="classic-modal-slide-description">
			<DialogTitle
				id="classic-modal-slide-title"
				disableTypography
				className={classNames(classes3.container, classes3.modalHeader)}>
				<Button
					simple
					className={classes3.modalCloseButton}
					key="close"
					aria-label="Close"
					onClick={() => setInformationDialogShow(false)}>
					{" "}
					<Close className={classes3.modalClose} />
				</Button>
				<h4 className={classNames(classes3.modalTitle)}>
					<img
						src={selectedDialogData.imageUrl}
						al={selectedDialogData.Heading}
						className={classes3.modelTitleImg}
					/>
				</h4>
			</DialogTitle>
			<DialogContent
				id="classic-modal-slide-description"
				className={classes3.modalBody}>
				<hr />
				<div className={classes3.paragraphBoldModel}>{selectedDialogData.Body}</div>
				<hr />
				<div className={classes3.paragraphTitleModel}>
					<span>
						<i className="fas fa-star" />
					</span>
					Key Features:
				</div>
				<div className={classes3.paragraphModel}>
					<ul>
						{selectedDialogData.KeyFeatures.map((feature, index) => (
							<li key={index}>
								<span>
									<i className="fas fa-angle-double-right" />
								</span>
								{feature}
							</li>
						))}
					</ul>
				</div>
			</DialogContent>
			<DialogActions className={classes3.modalFooter}>
				{selectedDialogData.download != "" && (
					<a
						href={selectedDialogData.download}
						target="_blank"
						rel="noopener noreferrer">
						<button className={classesCSStyles?.buttonPrimary}>
							Download the Current Pricebook
						</button>
					</a>
				)}
				<button
					className={classesCSStyles?.buttonPrimary}
					onClick={() => {
						requestAccess();
					}}>
					{checkIfHaveAccess(selectedDialogData.Heading)}
				</button>
			</DialogActions>
		</Dialog>
	);
};

export default InformationDialog;
